import { memo } from 'react';
// @mui

// ----------------------------------------------------------------------

function EnlargeIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.75 8.25033L18.3333 3.66699M18.3333 3.66699V7.33366M18.3333 3.66699H14.6667"
        stroke="#637381"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.25 13.7497L3.66667 18.333M3.66667 18.333V14.6663M3.66667 18.333H7.33333"
        stroke="#637381"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default memo(EnlargeIcon);
